import React, { useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

/**
 * Segura os filhos até a sessão terminar de carregar.
 *
 * `WhatsAppsProvider` e `LoggedInLayout` ficam fora das rotas privadas, então
 * montavam junto com o app e disparavam `/settings`, `/whatsapp` e
 * `/call/historical/...` no próprio `useEffect` de montagem — ANTES de o
 * `/auth/refresh_token` responder e do `Authorization` estar no lugar.
 *
 * O resultado eram requests que saíam sem sessão, voltavam 401 e (até a
 * correção em `politicaDeSessao`) apagavam o token recém-criado pelo login.
 * Com a política corrigida eles deixaram de derrubar a sessão, mas continuavam
 * saindo à toa: uma rodada de chamadas condenadas a falhar em todo carregamento
 * de página.
 *
 * Mostra o carregamento enquanto espera. As rotas privadas ficam DENTRO deste
 * componente, então o indicador do `Route` não chega a montar — sem um aqui, o
 * usuário olharia para uma tela em branco até o refresh responder.
 */
const AguardaSessao = ({ children }) => {
  const { loading } = useContext(AuthContext);
  if (loading) return <BackdropLoading />;
  return children;
};

export default AguardaSessao;
